<template>
  <div class="popup-overlayer">
    <div class="popup">
      <a @click="$emit('close')" href="javascript:void(0)" class="close-btn"><i class="fas fa-times"></i></a>
      <h2>Vonalkód importálás</h2>

      <form id="import-form">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <a class="link" href="assets/doc/vonalkod_sablon.xls">
                <i class="fa fa-download"></i>
                Sablon XLS letöltése
              </a>
            </div>

            <hr>

            <div class="form-group" :class="{ error: errors.length }">
              <label class="form-label">Feltöltés</label>
              <input @change="fileChanged" type="file" name="file" id="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
		          <div v-for="error in errors" :key="error.msg" class="form-error">{{ error.msg }}</div>
            </div>
          </div>

          <div class="col-sm-12 align-right">
            <button @click="upload" class="button" type="button" :disabled="loading">
              <i v-if="loading" class="fa fa-spinner fa-pulse fa-fw"></i>
              <span v-else>Importálás</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    request_id: String
  },
  data() {
    return {
      loading: false,
      files: [],
      errors: []
    };
  },
  methods: {
    fileChanged: function(e) {
      this.files = e.target.files || e.dataTransfer.files;
    },
    upload: function() {
      const _this = this;
      _this.loading = true;
      const formData = new FormData();
      formData.append('request_id', this.request_id);
      formData.append('file', this.files[0]);
      _this.$root.checkRootUserHasSet(function() {
        $.ajax({
          url: api_url + 'barcodeImport/' + _this.$root.user.apikey,
          type: 'POST',
          data: formData,
          success: function(response) {
            _this.loading = false;

            if (response.errors == undefined) {
              _this.$emit('success');
              _this.$emit('close');
            } else {
              _this.errors = response.errors;
            }
          },
          cache: false,
          contentType: false,
          processData: false
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// import.vue?ff30046e